<template>
<Dialog header="MAP" 
v-model:visible="show" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '75vw'}"
:modal="true"
>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="!loading">
<div class="w-full mb-3">
<h4 class="text-primary font-bold">Olası Seçenekler</h4>

<Listbox 
v-model="selected_location" 
:options="geocodes" 
@change="locationSelected"
optionLabel="formatted_address"
class="w-full mb-3" />



<GoogleMap
:api-key="apikey"
mapId="DEMO_MAP_ID"
style="width: 100%; height: 500px"
:center="center"
:zoom="8"
>
<AdvancedMarker 
v-for="geocode in geocodes"
:options="{position:geocode.geometry.location}" 
:pin-options="pinOptions"
/>
</GoogleMap> 
</div>



</template>



<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="hideModal" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting"/>

<Button 
v-if="location_selected"
:label="$store.state.languages.lang_phrases.kaydet" 
icon="pi pi-check" 
@click="submitLocation" 
class=" p-button-primary p-button-outlined  p-button-sm" 
:loading="$store.state.ui.submitting"/>

</template>



</Dialog>	
</template>

<script>
import { GoogleMap, AdvancedMarker } from 'vue3-google-map'
export default {

  name: 'EditorMapModal',

  data () {
    return {
    	show:false,
    	loading:true,
      apikey:process.env.VUE_APP_GMP_KEY,
      geocoder :null,
      center:null,
      location_selected:false,
      geocodes:[],
      selected_location:null,
    }
  },
  components:{GoogleMap,AdvancedMarker},
  computed:{
    pinOptions()
    {
      return { background: '#352f8d',borderColor:'#352f8d',glyphColor:"#ffffff" }
    }
  },
  watch:{
    show(newval,opdval)
    {
      this.location_selected = false
      this.loading = true
    }
  },
  methods:{
    locationSelected(data)
    {
      console.log(data)
      let loc = this.geocodes.find(item=>item.place_id = data.value)
      console.log(loc)
      console.log(this.selected_location)
      this.center = loc.geometry.location
      console.log(this.center)
    },
  	showModal(lat,lng)
  	{
  		this.show = true
      this.center = {lat:parseFloat(lat),lng:parseFloat(lng)}
      this.location_selected = true
      console.log(this.center)
      setTimeout(()=>{
        this.loading = false
      },500)
      
  	},
  	hideModal()
  	{  		
      if(!this.location_selected)
      {
        this.$emit("geolocationChangedCanceled")
      }
      
      setTimeout(()=>{
        this.show = false        
      })     
  	},
    submitLocation()
    {
      this.$emit("geolocationChanged",this.center)
      setTimeout(()=>{
        this.show = false        
      })
      
    },
    async getGeolocation(address)
    {
      this.show = true
      this.loading = true
      let string = address.replaceAll(" ","+")
      let url = "https://maps.googleapis.com/maps/api/geocode/json?address="+string+"&key="+this.apikey
      let geocode = await fetch(url) 
      geocode = await geocode.json();
      this.geocodes = geocode.results
      console.log(this.geocodes)
      if(this.geocodes.length)
      {
        this.center = this.geocodes[0].geometry.location
        if(this.geocodes.length===1)
        { 
          this.location_selected = true
        }
      }
      else
      {

      }
      
      this.loading = false
    },
  }
}
</script>

<style lang="css" scoped>
</style>